import React from 'react';
import fr from 'facet-rest';
import AuthenticationFactorModalActionModify
  from './AuthenticationFactorModalActionModify';
import AuthenticationFactorModalActionDefault
  from './AuthenticationFactorModalActionDefault';

export const ActionPicker = ({ authenticationFactorResource }) => {
  return authenticationFactorResource.withRelationship(fr.relationships.authenticationFactorModify.name, () => {
    return (
      <AuthenticationFactorModalActionModify authenticationFactorResource={authenticationFactorResource} />
    );
  }, () => {
    return (
      <AuthenticationFactorModalActionDefault authenticationFactorResource={authenticationFactorResource} />
    );
  });
};
